import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { Art57Node } from "../Art57Node";
import { OldDrugIngredient } from "../../../Data/Art57Data/OldDrugIngredient";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { ErrorControlUtil } from "../../../ErrorControlUtil";

export class TreeNodeOldDrugIngredient extends Art57Node {
  constructor(injector: Injector, parent: Art57Node) {
    super(
      injector,
      new OldDrugIngredient(new FieldDefinition(injector)),
      'Old Drug Ingredient'
    );
    this.parent = parent;
    this.labelNodeName = 'Old Drug Ingredient';
    this.ioc!.get(Art57Section).generateNumColumValue(this);
    this.refreshLabel();
  }

  override refreshLabel(lazy: boolean = true): void {

    let param1 = '';
    let param2 = '';
    let separator = '';

    if (this.data && this.data.model &&
      this.data.model.substancecode &&
      this.data.model.substancecode.value) {
      if (this.data.model.substancecode.name) {
        param1 = this.data.model.substancecode.name;
      } else if (!lazy) {
        this.ioc!.get(LookupGetService).getLookup('substance', this.data.model.substancecode.value + '_1')
          .then((result: CodeName) => {
            if (result && result.name && result.name != '') {
              this.data.model.substancecode.name = result.name;
              this.refreshLabel();
            }
          });
      }
    }

    if (this.data && this.data.model && this.data.model.roleofingredient) {
      param2 = this.ioc!.get(LookupGetService).retrieveValueFromCache('roleofingredient',
        this.data.model.roleofingredient);
    }

    if (param1 != '' || param2 != '') {
      if ((param1 != '') && (param2 != '')) {
        separator = ' - ';
      }
      this.label = param1 + separator + param2;
    } else {
      this.label = this.labelTemplate;
    }

  }

  override getListItem(): any[] {
    return [
      this.data.model &&
        this.data.model.substancecode &&
        this.data.model.substancecode.value
        ? this.data.model.substancecode.name
        : 'Not Selected',
      this.data.model && this.data.model.roleofingredient
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'roleofingredient',
          this.data.model.roleofingredient
        )
        : 'Not selected',
      this.data.model && this.data.model.concentrationtype 
        ? this.data.model.concentrationtype
        : '',
      this.data.model && this.data.model.concentrationunitcode
        ? this.data.model.concentrationunitcode
        : '',
      this.data.model && this.data.model.concentration
        ? this.data.model.concentration
        : '',
      this.data.model && this.data.model.concentration2
        ? this.data.model.concentration2
        : '',
    ];
  }

  override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
}